import { Component } from '@angular/core';
import { OERIService } from '../../../../services/oeri.service';
import { TableModule } from 'primeng/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { CommonService } from '../../../../services/common.service';
import { FormsModule, NgModel } from '@angular/forms';
import { ReportsService } from '../../../../services/reports.service';
import saveAs from 'file-saver';
import { NotificationService } from '../../../../services/notification.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-overdue-tlr-reports',
    imports: [TableModule, NgIf, DropdownModule, CommonModule, FormsModule, RouterModule],
    templateUrl: './overdue-tlr-reports.component.html',
    styleUrl: './overdue-tlr-reports.component.scss'
})
export class OverdueTlrReportsComponent {
  isShowMainBlock: boolean = false;
  divisionList =[]
  sectionsList =[]
  plantList  = []
  reportData: any = [];
  oeriStatistics: any = {
    lastCalled: '',
    openTlr : 0,
    removedIn30days : 0
  };

  paramSub: Subscription | undefined;
  
  constructor(private oeriService: OERIService,
    private notificationService:NotificationService,
    private report: ReportsService,
    private router:Router,
    private commonService : CommonService,
    private route: ActivatedRoute,
  ) { 

  }

  ngOnInit(){
    this.getOERIStatistics();
    this.getDivisionList();

    this.paramSub = this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length) {
        this.filters = { ...params} ;
        this.isShowMainBlock = true;
        this.getTlrOverdueData();
      } else {
        this.isShowMainBlock = false;
      }
    });
  }
  
  ngOnDestroy() {
    if (this.paramSub) {
      this.paramSub.unsubscribe();
    }
  }

  getOERIStatistics(){
    this.oeriService.getOeriStatistics().subscribe((response: any) => {
      this.oeriStatistics.lastCalled = this.commonService.formatDateTime(response.oeriLastCalledTLR);
      this.oeriStatistics.openTlr = response.openTLRsToOERI;
      this.oeriStatistics.removedIn30days = response.removedTLRsLast30DaysToOERI;

    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }
  getDivisionList() {
    this.report.getLDAREmissionbuildSearch('ES',false).subscribe(
      (data: any) => {
        this.divisionList = data.divisionItems;
        this.sectionsList = data.sectionItems;
        this.plantList = data.plantItems;
      },
      (error: any) => {
        console.error('Error fetching air compliance details', error);
      }
    );
  }
  filters = {
    division: 'ALL',
    section: 'ALL',
    plant: 'ALL',
  }
  runReport(){
    
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        division: this.filters.division ,
        section: this.filters.section,
        plant: this.filters.plant,
      },
      queryParamsHandling: 'merge',
    });
  }

  getTlrOverdueData() {
    let params = {
      division: this.filters.division,
      section: this.filters.section,
      plant: this.filters.plant,
      facilityId: localStorage.getItem('current_facility_id'),
    };
    this.oeriService.getTlrOverdueData(this.filters).subscribe((response: any) => {
      this.reportData = response || [];
    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }
  
  details(row: any){
    this.router.navigate(['/details-section', row.Tag_Number]);
  }

  exportToExcel() {

    this.oeriService.getTlrOverdueDataExcel(this.filters)
        .subscribe({
            next: (fileData: any) => {
                if (fileData) {
                    saveAs(fileData, 'TLR-OERIOverdueTLRDetail.xlsx');
                }
                this.notificationService.showSuccess("file downloaded successfully");
            },
            error: (err: any) => {
                console.error('Error fetching report details:', err);
            }
        });
}


  backBtn(){
    this.router.navigate(['/over-due-tlr-details-report']);
    
  }
  getDateClass(date: Date): string {
    date = new Date(date); // Convert to Date object if it's a string
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    if (date < today) {
      return 'past-date';
    } else  {
        return 'future-date';
      }
  }
} 
